module.exports = __webpack_public_path__ + "img/testimonial-03.97fd1192.jpg";